import {ActivatedRoute, Params} from '@angular/router';
import {FormGroup} from '@angular/forms';
import {IntelligenceSearchInterface} from '../models/intelligence-search.interface';


export const buildQueryParams = (search: IntelligenceSearchInterface): Params => {
  const queryParams = {};

  if (search?.year) {
    Object.assign(queryParams, {year: search.year});
  }
  if (search.region && search.region !== '') {
    Object.assign(queryParams, {region: search.region});
  }
  if (search.responseType && search.responseType !== '') {
    Object.assign(queryParams, {responseType: search.responseType});
  }
  if (search.categories && search.categories.length > 0) {
    Object.assign(queryParams, {categories: search.categories});
  }
  if (search.eWasteCategories && search.eWasteCategories.length > 0) {
    Object.assign(queryParams, {eWasteCategories: search.eWasteCategories});
  }
  if (search.order && search.order !== '') {
    Object.assign(queryParams, {order: search.order});
  }

  return queryParams;
};

export const getFiltersFromQueryParams = (params: Params): IntelligenceSearchInterface => {
  const search = {} as IntelligenceSearchInterface;

  if (params.year) {
    search.year = params.year;
  }
  if (params.region) {
    search.region = params.region;
  }
  if (params.responseType) {
    search.responseType = params.responseType;
  }
  if (params.categories) {
    if (typeof params.categories === 'string') {
      search.categories = Array(params.categories);
    } else {
      search.categories = params.categories;
    }
  }
  if (params.eWasteCategories) {
    if (typeof params.eWasteCategories === 'string') {
      search.eWasteCategories = Array(params.eWasteCategories);
    } else {
      search.eWasteCategories = params.eWasteCategories;
    }
  }
  if (params.order) {
    search.order = params.order;
  }
  return search;
};

export const setFormValuesFromQueryParams = (searchForm: FormGroup, activatedRouter: ActivatedRoute): void => {
  activatedRouter.queryParams.subscribe((params) => {

    if (params.year) {
      const year: number = +params.year;
      searchForm.get('year')?.setValue(year);
    }
    if (params.year) {
      searchForm.get('region')?.setValue(params.region);
    }
    if (params.categories) {
      searchForm.get('categories')?.setValue(params.categories);
    }
    if (params.eWasteCategories) {
      if (typeof params.eWasteCategories === 'string') {
        searchForm.get('eWasteCategories')?.setValue(Array(params.eWasteCategories));
      } else {
        searchForm.get('eWasteCategories')?.setValue(params.eWasteCategories);
      }
    }
    if (params.responseType) {
      searchForm.get('responseType')?.setValue(params.responseType);
    }
    if (params.order) {
      searchForm.get('order')?.setValue(params.order);
    }
  });
};

